import { render, staticRenderFns } from "./ArtefatosGeraisStatus.vue?vue&type=template&id=49bd40b8&scoped=true"
import script from "./ArtefatosGeraisStatus.vue?vue&type=script&lang=js"
export * from "./ArtefatosGeraisStatus.vue?vue&type=script&lang=js"
import style0 from "./ArtefatosGeraisStatus.vue?vue&type=style&index=0&id=49bd40b8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bd40b8",
  null
  
)

export default component.exports